module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "flash-swf"
    }
  }, [_c('object', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.flash_support),
      expression: "!flash_support"
    }]
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('object', {
    attrs: {
      "classid": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000",
      "width": "100%",
      "height": "100%",
      "id": "Scene"
    }
  }, [_c('param', {
    attrs: {
      "name": "movie",
      "value": "Scene.swf"
    }
  }), _vm._v(" "), _c('param', {
    attrs: {
      "name": "quality",
      "value": "high"
    }
  }), _vm._v(" "), _c('param', {
    attrs: {
      "name": "bgcolor",
      "value": "#ffffff"
    }
  }), _vm._v(" "), _c('param', {
    attrs: {
      "name": "allowScriptAccess",
      "value": "sameDomain"
    }
  }), _vm._v(" "), _c('param', {
    attrs: {
      "name": "allowFullScreen",
      "value": "true"
    }
  }), _vm._v(" "), _c('object', {
    attrs: {
      "type": "application/x-shockwave-flash",
      "data": "Scene.swf",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('param', {
    attrs: {
      "name": "quality",
      "value": "high"
    }
  }), _vm._v(" "), _c('param', {
    attrs: {
      "name": "bgcolor",
      "value": "#ffffff"
    }
  }), _vm._v(" "), _c('param', {
    attrs: {
      "name": "allowScriptAccess",
      "value": "sameDomain"
    }
  }), _vm._v(" "), _c('param', {
    attrs: {
      "name": "allowFullScreen",
      "value": "true"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n                     亲~您的电脑没有安装flash最新版,或者浏览器禁用了flash\n                  ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.adobe.com/go/getflashplayer"
    }
  }, [_c('img', {
    attrs: {
      "src": "http://www.adobe.com/images/shared/download_buttons/get_flash_player.gif",
      "alt": "Get Adobe Flash Player"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64c5db73","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Flash/FlashSwf.vue
// module id = 394
// module chunks = 0